import { serializable } from 'serializr';
import { optional } from '../validation/Validator';
import { expandUrlTemplate } from '../utilities/UrlTemplates';

/**
 * Represents a HAL link object.  See [[HalIO]] and [HAL](http://stateless.co/hal_specification.html)
 */
export class LinkModel {

   /**
    * The href of the link
    */
   @serializable
   href: string;

   /**
    * Whether or not the href is a templated url
    */
   @serializable @optional
   templated?: boolean;

   @serializable @optional
   type?: string;

   @serializable @optional
   deprecation?: string;

   /**
    * The name of the link
    */
   @serializable @optional
   name?: string;

   @serializable @optional
   profile?: string;

   /**
    * The title of the link, for use in drop downs and such
    */
   @serializable @optional
   title?: string;

   @serializable @optional
   hreflang?: string;

   constructor(href: string, title?: string | undefined, name?: string | undefined, templated?: boolean | undefined) {

      this.href = href;
      this.title = title;
      this.name = name;
      this.templated = templated;
   }

   /**
    * Call this function to return the href.  For templated urls, pass an expand
    * object to expand the href [RFC-6570](https://www.npmjs.com/package/uri-template)
    *
    *
    * @param {object | undefined} expand An optional expand object for expanding templated URLs
    * @returns {string} Returns the href
    */
   getHref(expand: Record<string, unknown> = {}): string {

      if (this.templated) {
         return expandUrlTemplate(this.href, expand);
      }
      return this.href;
   }

   getName(): string | undefined {
      return this.name;
   }

   getTitle(): string | undefined {
      return this.title;
   }

   getType(): string | undefined {
      return this.type;
   }

   getProfile(): string | undefined {
      return this.profile;
   }

   getDeprecation(): string | undefined {
      return this.deprecation;
   }

   getHreflang(): string | undefined {
      return this.hreflang;
   }

   isTemplated(): boolean {

      return this.templated || false;
   }
}
